<script setup lang="ts">

const { getFavoriteFAQ } = useFAQ()
const { data: faqItems } = await useAsyncData('home-faq', () => getFavoriteFAQ())

const openIndex = ref<number | null>(0)

const toggle = (index: number) => {
  openIndex.value = openIndex.value === index ? null : index
}
</script>

<template>
  <section id="faq" class="py-section-py bg-background relative overflow-hidden transition-colors duration-300">
    <!-- Background Elements -->
    <div class="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30">
        <div class="absolute top-1/4 -right-20 w-96 h-96 bg-oxo-red/10 rounded-full blur-3xl"></div>
        <div class="absolute bottom-1/4 -left-20 w-96 h-96 bg-oxo-yellow/10 rounded-full blur-3xl"></div>
    </div>

    <div class="container mx-auto px-container-px relative z-10">
      <UiSectionHeader 
        titlePrefix="QUESTIONS"
        titleHighlight="FRÉQUENTES"
        subtitle="Tout ce que vous devez savoir avant de rejoindre l'aventure OXO."
        class="mb-section-header-mb"
      />

      <dl class="max-w-3xl mx-auto space-y-4">
        <div 
          v-for="(item, index) in faqItems" 
          :key="index"
          class="group bg-oxo-card-bg rounded-xl border border-oxo-border overflow-hidden transition-all duration-300 hover:border-oxo-red/30"
        >
          <dt>
            <button 
              @click="toggle(index)"
              class="w-full flex items-center justify-between p-6 text-left focus:outline-hidden"
              :aria-expanded="openIndex === index"
            >
              <span class="text-lg font-bold text-foreground group-hover:text-oxo-red transition-colors">
                {{ item.question }}
              </span>
              <div 
                class="relative w-8 h-8 flex items-center justify-center rounded-full bg-background transition-colors group-hover:bg-oxo-red/10"
              >
                <i :class="{ 'rotate-45': openIndex === index }" class="fas fa-plus text-foreground-dim group-hover:text-oxo-red transition-transform duration-300" aria-hidden="true"></i>
              </div>
            </button>
          </dt>
          
          <dd 
            class="overflow-hidden transition-all duration-300 ease-in-out"
            :style="{ maxHeight: openIndex === index ? '200px' : '0px', opacity: openIndex === index ? 1 : 0 }"
          >
            <div class="p-6 pt-0 text-foreground-dim leading-relaxed">
              {{ item.answer }}
            </div>
          </dd>
        </div>
      </dl>


      <div class="flex flex-col items-center justify-center mt-12 gap-4">
        <AppButton to="/faq" variant="outline" size="sm">
          Voir toute la FAQ
          <i class="fas fa-arrow-right ml-2" aria-hidden="true"></i>
        </AppButton>

        <p class="text-foreground-dim mt-4">
          Vous avez d'autres questions ?
        </p>
        <AppButton variant="primary" to="/contact">
          Contactez-nous
        </AppButton>
      </div>
    </div>
  </section>
</template>
